module.exports = __webpack_public_path__ + "img/logoTRW.f0294a84.png";